<template>
    <svg aria-hidden="true" focusable="false" width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.5" cy="20.5" r="20" stroke="#9D9FA2" />
        <path
            d="M11.275 11.4275H16.7318L21.7756 18.0832L28.0538 11.275L29.5456 11.3004L22.5193 19.0406L29.725 28.5475H24.2705L19.5099 22.3452L13.6942 28.7H12.2263L18.7878 21.4385L11.275 11.4275ZM16.2172 12.4104H13.3354L24.865 27.5392H27.695L16.2172 12.4104Z"
            fill="black" />
    </svg>
</template>
